module.exports = __webpack_public_path__ + "img/symbol_1.d20e4077.png";